import { dedupeResources } from '../lib/contentUtils';

export function ResourceLinks({
  resources,
}: {
  resources: { label: string | null; url: string }[];
}) {
  const links = dedupeResources(resources);
  if (links.length === 0) return null;

  return (
    <section className="resource-links">
      <h3>Sources & further reading</h3>
      <ul>
        {links.map((r) => (
          <li key={r.url}>
            <a href={r.url} target="_blank" rel="noopener noreferrer">
              {r.label ?? new URL(r.url).hostname}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
